<template>
  <div id="NoAuthPage">无权限</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
